module.exports = __webpack_public_path__ + "static/media/get_consistent.b9a627bb.gif";